import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useForm, Form } from "../../../controls/useForm";
import { Payment } from "../payment/Payment";
import { store } from "../../../../redux-store/store";
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';


export default function NewCredit({ amount, drop, cartItems }) {
    const initialFValues = {
        cashRecieved: "",
        customerName: "",
        accountId: 0,
        sendBy: "",
        referenceNumber: "",
        customerId: 0,
        phoneNumber: "",
        paymentTypeId: 0,
        accountTypeId: 0,
        cardTypeId: 0,
    };

    const [paymentL, setPayment] = React.useState('');
    const [tenure, setTenure] = useState(0);
    const [repayment, setRePayment] = useState(0)
    const [totalAmount, setTotalAmount] = useState(amount)
    const [finalAmount, setFinalAmount] = useState(0)
    const [financingCharges, setFinancialCharges] = useState(0)
    const handlePayment = (event) => {
        setPayment(event.target.value);
    };
    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
        useForm(initialFValues, true, () => { });

    function Repayment() {

    } 
  
    var credit = store.getState().persistReducer.credit
    function GetPeriod() {
        var type = "";
        var financingCharges = 0;
        var repayment = 0;


        if (credit != null || undefined) {
            if (credit.isCredit) {
                if (credit.periodId == 1) {
                    type = "DAILY"

                }
                else if (credit.periodId == 2) {
                    type = "Weekly"
                }
                else if (credit.periodId == 3) {
                    type = "Monthly"
                }
                else if (credit.periodId == 4) {
                    type = "Quarterly"
                }
                else if (credit.periodId == 5) {
                    type = "yearly"
                }
            }
        }
        return type;
    }

    return (
        <Container className="flex flex-col space-y-5">
            <div className="w-100">
                <Controls.Input
                    label="Total Sales Amount"
                    name="Sales Amount"
                    readOnly
                    value={totalAmount}
                />{" "}
            </div>
            <div>
                <Controls.Select
                    name="customerId"
                    label="Drop"
                    value={values.customerId || ""}
                    onChange={handleInputChange}
                    options={drop}
                    error={errors.dropId}
                />
            </div>

            <div className="w-100">
                <Controls.Input
                    label="Overall Total  Amount"
                    name="Sales Amount"
                    readOnly
                    value={finalAmount}
                />{" "}
            </div>

            <div className="w-100">
                <Controls.Input
                    name="unit"
                    label="Financial Charges"
                    readOnly
                    value={financingCharges}
                />
            </div>
            <div className="w-100">
                <Controls.Input
                    name="unit"
                    label="Tenour of Credit"
                    onChange={(e) => {
                       
                        var credit = store.getState().persistReducer.credit;
                        var amountV = 0;
                        setTenure(e.target.value)
                        if (credit.periodId == 1) {
                            amountV = totalAmount * (credit.interest / 365 * e.target.value).toFixed(2)
                        }
                        else if (credit.periodId == 2) {

                            amountV = totalAmount * (credit.interest / 52 * e.target.value).toFixed(2)

                        }
                        else if (credit.periodId == 3) {
                            amountV = totalAmount * (credit.interest / 12 * e.target.value).toFixed(2)

                        }
                        else if (credit.periodId == 4) {
                            amountV = totalAmount * (credit.interest / 4 * e.target.value).toFixed(2)

                        }
                        else if (credit.periodId == 5) {
                            amountV = totalAmount * credit.interest * e.target.value

                        }
                        setFinancialCharges(amountV)
                        setRePayment((totalAmount + amountV / e.target.value).toFixed(2));
                        setFinalAmount((totalAmount + amountV).toFixed(2))

                    }}
                />
            </div>
            <div className="w-100">
                <InputLabel id="demo-simple-select-label">{GetPeriod()}</InputLabel>
            </div>
            <div className="w-100 m-0">
                <Controls.Input
                    name="unit"
                    label="Repayment"
                    readOnly
                    value={repayment}
                />
            </div>
            <Button onClick={() => {
                var payload = {
                    paymentTypeId: 0,
                    salesOrders: cartItems,
                    cashRecieved: totalAmount,
                    vat: 0,
                    discount: 0,
                    vatcal: 0,
                    financingCharges: financingCharges,
                    repayment: repayment,
                    paymentFrequencyId: credit.periodId,
                    creditTenour: tenure,
                    discountcal: 0,
                    customerId: values.customerId,
                    transactionReference: cartItems[0]?.transactionReference,
                    sendBy: values.sendBy,
                    accountId: 0,
                    cardTypeId: 0,
                    isCredit: true,
                    accountTypeId: 0,
                };

                store.dispatch({ type: "ADD_PAYMENT", payload });
            }} variant="contained" className="text-white w-full" style={{ backgroundColor: "#3f51b5" }}>
                Save
            </Button>
        </Container>
    );
}
